import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../../services/api/client';
import { queryKeys } from '../../lib/queryClient';
import type { SubscriptionTier } from '../../lib/tiers';
import type { Organization } from '../../types/api';

/** Tiers that can be trialled. Sprout is the only sellable paid tier. */
export type TrialEligibleTier = Exclude<
  SubscriptionTier,
  'seedling' | 'sapling' | 'canopy' | 'forest'
>;

/**
 * Start a 14-day trial of a paid tier on the current organization.
 *
 * On success, invalidates the current-organization query so any consumers
 * of useSubscriptionTier / useTrialStatus pick up the new effective_tier.
 */
export function useStartTrial() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (tier: TrialEligibleTier): Promise<Organization> => {
      const response = await apiClient.post<Organization>(
        '/organizations/current/trial',
        { tier }
      );
      return response.data;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.organizationCurrent() });
    },
  });
}
